{
  "name": "Vishnu Kumar",
  "title": "Full-Stack & Machine Learning Systems Engineer",
  "location": "Agra, Uttar Pradesh, India",
  "email": "dev.vishnu.git@gmail.com",
  "phone": "+91 90278 72285",
  "photo": "https://avatars.githubusercontent.com/u/233461563?v=4",
  "github": "https://github.com/HelloVishnu04/",
  "linkedin": "https://www.linkedin.com/in/vishnu-kumar-07654a2a1/",
  "bio": "Full-Stack and Machine Learning Engineer with production experience building REST APIs, real-time data pipelines, and ML-powered backend systems using Python (FastAPI, Flask, Django/DRF), React, and Node.js. Skilled in containerized microservices (Docker), CI/CD automation (GitHub Actions), and deploying NLP and deep learning models to production. IBM SkillsBuild AI/ML intern and OCI Data Science Professional certified. B.Tech Computer Science student (expected 2027) seeking Backend Engineer and Machine Learning Engineer roles.",
  "heroDescription": "Building REST APIs, real-time data pipelines, and ML-powered backend systems. Shipping type-safe, accessible web apps.",
  "skills": {
    "Languages": [
      "Python",
      "JavaScript/TypeScript",
      "Java",
      "SQL"
    ],
    "Backend & APIs": [
      "FastAPI",
      "Flask",
      "Django REST Framework",
      "REST API Design",
      "Microservices",
      "WebSockets",
      "JWT Authentication"
    ],
    "Frontend": [
      "React",
      "MERN Stack",
      "HTML5",
      "CSS3/SCSS",
      "Responsive UI Design"
    ],
    "Databases & Data": [
      "PostgreSQL",
      "MySQL",
      "MongoDB",
      "Redis",
      "FAISS",
      "ChromaDB",
      "PySpark",
      "ETL"
    ],
    "Machine Learning & NLP": [
      "TensorFlow",
      "Keras",
      "Scikit-learn",
      "XGBoost",
      "Pandas",
      "NumPy",
      "Hugging Face",
      "OpenAI API",
      "Random Forest",
      "LangChain & LangSmith",
      "Bidirectional LSTM"
    ],
    "DevOps & Cloud": [
      "Docker",
      "GitHub Actions (CI/CD)",
      "MLflow",
      "AWS",
      "Oracle Cloud Infrastructure (OCI)"
    ]
  }
}